/* 📦 LIBS */
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TourProvider } from "@reactour/tour";
import { AnimatePresence } from "framer-motion";

/* 🧩 COMPONENTS */
import { Template, Button } from "../Components";

/* 📄 PAGES */
import { Home, ControlMain, UserProfile, ConfirmaEmail, DashboardEquipamento, DashboardControlePerdas, ResetPassword, ListUsers, ListAlocacoes, ViewAlocacoes, 
    ListEquipaments, ViewEquipaments, HistoricDetailed, HistoricGeneral, HistoricOnlyAnalysis, HistoricOperationMode, ListRoles, ViewRole, 
    ListMaintenance, MaintenanceReports, OnlyGraphs, ListGroups, GroupView, ListPartsCommands, ViewPartsCommands, ListPartsCommandsVariables, 
    ViewPartsCommandsVariables, ListPartCommandsHasVariables, ViewPartCommandsHasVariables, ListPartsCommandsVariablesAlarms, ViewPartsCommandsVariablesAlarms, 
    ListEquipamentHasPartCommands, ViewEquipamentHasPartCommands, ListGroupVariables, ViewGroupVariables, ListPartCommandsVariablesAcceptUnits, 
    ViewPartCommandsVariablesAcceptUnits, ListPartCommandsVariablesAcceptValues, ViewPartCommandsVariablesAcceptValues, ListLogs, ListPermissions, 
    ViewPermission, IPCLogsList, AdminCruds, EquipCruds, LogsCruds, EquipmentTypeList, EquipmentTypeView } from "../Pages"
import { NotFound } from "../Pages/Error";

/* 🧠 REDUX */
import { store } from "../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { ChangeCheckedTutorial } from "../Redux/Actions";

/* 📁 ASSETS*/
import { Prev, Next } from "../Assets/icons";

/* 🎨 STYLES */
import { Icon } from "../Components/styles";

/* 🔧 UTILS */
import { tourConfig } from "../util/tour";

// Colocar todas as rotas autenticadas aqui dentro
const AppRoutes = () => {

    const tourStyles = {
        popover: (base) => ({
            ...base,
            borderRadius: 15,
            padding: "20px",
            width: '100%',       // ocupa toda a largura disponível
            maxWidth: window.innerWidth >= 720 ? '480px' : '350px',  // responsivo
            zIndex: '99999999',
        }),
        badge: (base) => ({ ...base, display: 'none' }),
        maskArea: (base) => ({ ...base, zIndex: '99999999' }),
        maskWrapper: (base) => ({ ...base, zIndex: '99999999' }),
        dot: (base, state) => ({
            ...base,
            backgroundColor: state.current ? '#006560' : 'transparent',
            border: '1px solid #006560',
            borderRadius: '50%',
            height: 10,
            margin: '0 2.5px',
            width: 10,
        }),
        close: (base) => ({ ...base, display: 'none'}),
        navigation: (base) => ({ ...base, display: 'flex', justifyContent: 'center', gap: 3, padding: 6, }), 
    }
    
    const { t } = useTranslation();
    const location = useLocation();

    const user = useSelector(state => state.userReducer);
    const checkedTutorial = useSelector(state => state.mapReducer.checkedTutorial);


    const currentPath = location.pathname;
    const config = tourConfig();
    const matchedRoute = config.find(route => route.match(currentPath));

    const nextHandler = matchedRoute?.next || (() => {});
    const prevHandler = matchedRoute?.prev || (() => {});

    return(
        <AnimatePresence>
            <TourProvider 
            steps={[]}  
            disableDotsNavigation // Desabilitar a navegação através dos prontos para evitar bug
            disableKeyboardNavigation
            showNavigation={checkedTutorial}
            onClickMask={({ setIsOpen, setCurrentStep }) => {
                setIsOpen(false);
                setCurrentStep(0);
                !checkedTutorial && store.dispatch(ChangeCheckedTutorial(true));
            }}
            prevButton={({ currentStep, isOpen, setCurrentStep, setIsOpen }) => (
                <Button 
                onClick={() => prevHandler(currentStep, setCurrentStep, setIsOpen)} 
                icon={<Icon src={Prev} />} 
                disabled={isOpen || currentStep === 0}
                padding={"6px"} 
                radius={"50%"} 
                />
            )}
            nextButton={({ currentStep, setCurrentStep, setIsOpen, steps }) => (
                <Button 
                iconPosition={"right"}
                text={t("buttons.next")}
                color={"green"} 
                onClick={() => nextHandler(currentStep, setCurrentStep, setIsOpen, steps.length)} 
                icon={<Icon src={Next}/>} 
                padding={"8px 10px"} 
                radius={"10px"}              
                />
            )}
            styles={tourStyles}
            >
            <Routes>
                <Route path="/login" element={<Navigate to={'/'}/>}/>
                <Route path="/" element={
                    <Template child={<Home/>}/>
                }/>

                {/* Controle */}
                <>
                    <Route path="/controle" element={
                        <Template child={<ControlMain/>}/>
                    }/>

                    <Route path="/controle/:equipamento" element={
                        <Template child={<ControlMain/>}/>
                    }/>
                </>

                {/* Dash */}
 
                <>
                    <Route path="/dashboard" element={
                        <Template child={<DashboardEquipamento/>}/>
                    }/>

                    <Route path="/dashboard/:equipamento" element={
                        <Template child={<DashboardEquipamento/>}/>
                    }/>

                    {user?.user?.can?.includes('loss_control.sanep') ?
                        <>
                            <Route path="/dashboard/perdas" element={
                                <Template child={<DashboardControlePerdas/>}/>
                            }/>
                        </>
                    : null}
                </>

                {/* Users */}
                <>
                    <Route path="/perfil" element={
                        <Template child={<UserProfile/>}/>
                    }/>

                    <Route path="/perfil/confirmaemail/:token" element={
                        <Template child={<ConfirmaEmail/>}/>
                    }/>
                    
                    <Route path="/perfil/reset-password/:token" element={
                        <Template child={<ResetPassword/>}/>
                    }/>
                    
                    {/* {user?.user?.can?.includes('user.index') ?
                        <>
                            <Route path="/adm/funcionarios" element={
                                <Template child={<ListUsers/>}/>
                            }/>

                            <Route path="/adm/perfil/:userId" element={
                                <Template child={<UserProfile/>}/>
                            }/>
                        </>
                    : null} */}
                    
                        <>
                            <Route path="/adm/funcionarios" element={
                                <Template child={<ListUsers/>}/>
                            }/>

                            <Route path="/adm/perfil/:userId" element={
                                <Template child={<UserProfile/>}/>
                            }/>
                        </>
                    
                </>

                {/* Cruds */}
                
                    <>
                        <Route path="/adm/funcionarios/admin-cruds" element={
                            <Template child={<AdminCruds/>}/>
                        }/>
                    </>

                    <>
                        <Route path="/adm/equipamentos/equip-cruds" element={
                            <Template child={<EquipCruds/>}/>
                        }/>
                    </>

                    <>
                        <Route path="/adm/logs/logs-cruds" element={
                            <Template child={<LogsCruds/>}/>
                        }/>
                    </>
                    
                    
                    {/* Alocações */}
                    {user?.user?.can?.includes('allocation.index') ?
                        <>
                            <Route path="/adm/alocacoes" element={
                                <Template child={<ListAlocacoes/>}/>
                            }/>

                            <Route path="/adm/alocacoes/:id" element={
                                <Template child={<ViewAlocacoes/>}/>
                            }/>
                        </>
                    :null}

                    {/* Equipamentos */}
                    {user?.user?.can?.includes('equipment.index') ?
                        <>
                            <Route path="/adm/equipamentos" element={
                                <Template child={<ListEquipaments/>}/>
                            }/>

                            <Route path="/adm/equipamentos/:id" element={
                                <Template child={<ViewEquipaments/>}/>
                            }/>

                            <Route path="/adm/tipos-equipamentos" element={
                                <Template child={<EquipmentTypeList/>}/>
                            }/>

                            <Route path="/adm/tipos-equipamentos/:id" element={
                                <Template child={<EquipmentTypeView/>}/>
                            }/>
                        </>
                    :null} 
                    

                    {/* Grupos */}
                    {user?.user?.can?.includes('group.index') ?

                        <>
                            <Route path="/adm/grupos" element={
                                <Template child={<ListGroups/>}/>
                            }/>

                            <Route path="/adm/grupos/:id" element={
                                <Template child={<GroupView/>}/>
                            }/>

                        </>
                    :null}

                    {/* Permissões */}
                    {user?.user?.can?.includes('permission.index') ?
                        <>
                            <Route path="/adm/permissoes" element={
                                <Template child={<ListPermissions/>}/>
                            }/>

                            <Route path="/adm/permissoes/:id" element={
                                <Template child={<ViewPermission/>}/>
                            }/>
                        </>
                    :null} 

                    {/* Cargos */}
                        <>
                            <Route path="/adm/cargos" element={
                                <Template child={<ListRoles/>}/>
                            }/>

                            <Route path="/adm/cargos/:id" element={
                                <Template child={<ViewRole/>}/>
                            }/>
                        </>

                    {/* Interface de comandos */}
                    {(user?.user?.id === "7d3ad31c-572c-4be2-811f-9b4f14a9564f" 
                        || user?.user?.id === "182fbfd6-86ab-4fa2-b588-c12825c64361" 
                        || user?.user?.id === '52984c5a-b903-4577-8131-a48981dc8ffb0'
                        || user?.user?.id === "2123e214-6dde-4dc0-9911-41b17ff4b067" 
                        || user?.user?.id === "310a93b7-a4d7-47c9-ad75-0ae389d7ff2d"
                    ) &&
                        <>
                            <Route path="/PartCommands" element={
                                <Template child={<ListPartsCommands/>}/>
                            }/>
                            <Route path="/PartCommands/:id" element={
                                <Template child={<ViewPartsCommands/>}/>
                            }/>

                            <Route path="/PartCommandsVariables" element={
                                <Template child={<ListPartsCommandsVariables/>}/>
                            }/>
                            <Route path="/PartCommandsVariables/:id" element={
                                <Template child={<ViewPartsCommandsVariables/>}/>
                            }/>

                            <Route path="/PartCommandsHasVariables" element={
                                <Template child={<ListPartCommandsHasVariables/>}/>
                            }/>
                            <Route path="/PartCommandsHasVariables/:id" element={
                                <Template child={<ViewPartCommandsHasVariables/>}/>
                            }/>

                            <Route path="/PartCommandsVariablesAlarms" element={
                                <Template child={<ListPartsCommandsVariablesAlarms/>}/>
                            }/>
                            <Route path="/PartCommandsVariablesAlarms/:id" element={
                                <Template child={<ViewPartsCommandsVariablesAlarms/>}/>
                            }/>

                            <Route path="/EquipmentHasPartsCommands" element={
                                <Template child={<ListEquipamentHasPartCommands/>}/>
                            }/>
                            <Route path="/EquipmentHasPartsCommands/:id" element={
                                <Template child={<ViewEquipamentHasPartCommands/>}/>
                            }/>
                        
                            <Route path="/EncapsuledVariablesGroups" element={
                                <Template child={<ListGroupVariables/>}/>
                            }/>
                            <Route path="/EncapsuledVariablesGroups/:id" element={
                                <Template child={<ViewGroupVariables/>}/>
                            }/>        

                            <Route path="/PartCommandsVariablesAcceptUnits" element={
                                <Template child={<ListPartCommandsVariablesAcceptUnits/>}/>
                            }/>
                            <Route path="/PartCommandsVariablesAcceptUnits/:id" element={
                                <Template child={<ViewPartCommandsVariablesAcceptUnits/>}/>
                            }/>

                            <Route path="/PartCommandsVariablesAcceptValues" element={
                                <Template child={<ListPartCommandsVariablesAcceptValues/>}/>
                            }/>
                            <Route path="/PartCommandsVariablesAcceptValues/:id" element={
                                <Template child={<ViewPartCommandsVariablesAcceptValues/>}/>
                            }/>     

                        </>
                    }
                {/*  */}


                {/* Históricos */}
                <>
                    <Route path="/historico/detalhes/:id" element={
                        <Template child={<HistoricDetailed/>}/>
                    }/>
                    <Route path="/historico/detalhes" element={
                        <Template child={<HistoricDetailed/>}/>
                    }/>

                    <Route path="/historico/:id" element={
                        <Template child={<HistoricGeneral/>}/>
                    }/>
                    <Route path="/historico" element={
                        <Template child={<HistoricGeneral/>}/>
                    }/>

                    <Route path="/historico/analises/:id" element={
                        <Template child={<HistoricOnlyAnalysis/>}/>
                    }/>
                    <Route path="/historico/analises" element={
                        <Template child={<HistoricOnlyAnalysis/>}/>
                    }/>

                    <Route path="/historico/operacao/:id" element={
                        <Template child={<HistoricOperationMode/>}/>
                    }/>
                    <Route path="/historico/operacao" element={
                        <Template child={<HistoricOperationMode/>}/>
                    }/>

                    <Route path="/historico/graphs" element={
                        <Template child={<OnlyGraphs/>}/>
                    }/>
                </>

                {/* Manutenção */}
                <>
                    <Route path="/manutencoes" element={
                            <Template child={<ListMaintenance/>}/>
                        }/>
                    
                    <Route path="/manutencoes/report" element={
                            <Template child={<MaintenanceReports/>}/>
                        }/>
                </>

                {/* LOGS */}
                {/* {user?.user?.can?.includes('log.index') &&
                    <Route path="/adm/logs" element={
                        <Template child={<ListLogs/>}/>
                    }/>
                } */}
                {/* {user?.user?.can?.includes('log.index') && */}
                    <Route path="/adm/logs" element={
                        <Template child={<ListLogs/>}/>
                    }/>
                {/* } */}
                {user?.user?.can?.includes('ipc.debug') &&
                    <Route path="/adm/IPClogs" element={
                        <Template child={<IPCLogsList/>}/>
                    }/>
                }

                <Route path="*" element={
                    <Template child={<NotFound/>}/>
                }/>
            </Routes>
            </TourProvider>
        </AnimatePresence>
    )
}

export default AppRoutes;